import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import CountdownTimer from "../shared/components/CountdownTimer/CountdownTimer";
import {
  addEventListeners,
  removeEventListeners,
} from "../shared/utilitties/eventListener.util";
import { PrivateRoutes } from "../shared/models/routes";
import { useGlobalContext } from "../shared/context/global.context";
import { isNullOrEmpty } from "../shared/utilitties/string.utilities";

const CommonRedirectPage : (params: {text?: string}) => JSX.Element = ({text}) => {
  const {setRedirectTo} = useGlobalContext()
  const [redirect,setRedirect] = useState(false) 
  useEffect(() => {
    setRedirectTo("Home")
    const createTimeout1 = () =>
      setTimeout(() => {
        setRedirect(true)
      }, 5000);
    let timeout = createTimeout1();
    const listener = () => {
      timeout = createTimeout1();
    };

    addEventListeners(listener);
    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
      setRedirectTo("")
    };
  }, []);

  const NOW_IN_MS = new Date().getTime();
  const dateTimeAfterThreeDays = NOW_IN_MS + 5000;
  if(redirect) return <Redirect to={PrivateRoutes.HOME}/>;

  return (
    <>
      <div className="p-d-flex-column p-ai-center p-jc-center mt-2">
        <h2 className="p-d-flex p-ai-center p-jc-center">
          {" "}
          {isNullOrEmpty(text) ? 
            "Pagina no encontrada " : 
            `${text} `
          }
        </h2>
        <CountdownTimer targetDate={dateTimeAfterThreeDays}  rateLimit={false} />
      </div>
    </>
  );
};

export default CommonRedirectPage;
